import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';

import SimpleBottomNavigation from './SimpleBottomNavigation';
import './nav.scss';
import SearchHeader from './SearchHeader';
import DesktopHeaderSkeleton from 'app/shared/components/skeleton/desktop-header/header';
import Rigthmenu from './Rightmenu';
import { Grid } from '@material-ui/core';
import { AuthenticationState } from 'app/modules/user/service/store/state';
import { useSelector } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
export default function PrimarySearchAppBar({ router, cmsNavBar, DesktopType }) {
  const authentication: AuthenticationState = useSelector<IRootState>(state => state.authentication) as AuthenticationState;
  const appStyle: any = useSelector<IRootState>(state => state.cms.documents['app_global_type']);
  const contracts: any = useSelector<IRootState>(state => state?.contract?.subscriptionList);
  const loadingContract: any = useSelector<IRootState>(state => state?.contract?.loading);
  const loadingClaim: any = useSelector<IRootState>(state => state?.claim?.loading);
  const claims: any = useSelector<IRootState>(state => state?.claim?.claimsList);

  return (
    <div className="desktop-header">
      <AppBar position="static" className="">
        <Toolbar>
          <Grid className="header-desktop-logo">
            <img src={appStyle?.data?.main_logo?.url} alt="SPB LOGO" className='img-logo' />
          </Grid>
          {authentication?.isAuthenticated ? (
            <>
              {loadingContract || loadingClaim ? <DesktopHeaderSkeleton /> : (
                <Grid className="header-desktop-content">
                  <SimpleBottomNavigation
                    router={router?.params?.NAV_BAR_ITEM?.navBarItemList || []}
                    cmsNavBar={cmsNavBar}
                    claims={claims}
                    contracts={contracts}
                    DesktopType={DesktopType}
                    loading={loadingContract}
                  />
                </Grid>
              )
              }
              <Grid className="col-2">
                {' '}
                <SearchHeader
                  router={router?.sousComponentDataList?.find(x => x.componentDataKey === 'NAVBAR_SEARCH_DATA')?.actioDataList}
                />
              </Grid>
              <Grid className="header-desktop-right-menu">
                <Rigthmenu
                  router={router?.sousComponentDataList?.find(x => x.componentDataKey === 'NAVBAR_RIGHT_NAVIGATION')?.actioDataList}
                  cmsNavBar={cmsNavBar}
                />
              </Grid>
            </>
          ) : (
            ''
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
}
